import { cx } from "@linaria/core";



import { Card } from "./molecule.card";
import { ScrambledCard } from "./molecule.scrambled-card";
import * as styles from "./organism.cta.style";
import { CtaComponentCard } from "@courses-pm2/api/src/ts";

type Props = {
  portalId: string;
  title?: string;
  isScrambled?: boolean;
  cards: Array<CtaComponentCard>;
};

export function CallToActionComponent(props: Props): React.JSX.Element {
  return (
    <div
      className={styles.wrapper}
      data-card-count={Math.min(props.cards.length, 10)}
    >
      {props.title && (
        <h2 className={cx(styles.heading, props.isScrambled && "scrambled")}>
          {props.title}
        </h2>
      )}

      <ul className={styles.cardsList}>
        {props.cards.map((card, index) => (
          <li key={index} className={styles.card}>
            {!props.isScrambled ? <Card portalId={props.portalId} card={card} /> : <ScrambledCard />}
          </li>
        ))}
      </ul>
    </div>
  );
}
